import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Clock, LogoutSurface } from '@cubigo/digital-signage';

import { TranslateModule } from '@ngx-translate/core';

import { AuthService } from 'app/shared/services';

// Long enough for someone who meant it to reach the screen, short enough that an accidental
// ten-second press on the community logo puts the display back to work on its own.
const CONFIRMATION_TIMEOUT_MS = 30_000;

@Component({
  selector: 'app-logout',
  imports: [TranslateModule],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly clock = inject(Clock);
  private readonly expiry = new AbortController();
  private surface: LogoutSurface = LogoutSurface.Url;

  public readonly confirming = signal(true);

  public constructor() {
    inject(DestroyRef).onDestroy(() => this.expiry.abort());
  }

  public ngOnInit(): void {
    const requested = this.route.snapshot.queryParamMap.get('surface');
    this.surface = requested === LogoutSurface.LogoHold || requested === LogoutSurface.TvRemote ? requested : LogoutSurface.Url;
    void this.clock.after(CONFIRMATION_TIMEOUT_MS, this.expiry.signal)
      .then((): void => this.cancel(), (): void => undefined);
  }

  public confirm(): void {
    if (!this.confirming()) {
      return;
    }

    this.expiry.abort();
    this.confirming.set(false);
    void this.authService.logoutAndNavigate(this.surface);
  }

  public cancel(): void {
    if (!this.confirming()) {
      return;
    }

    this.expiry.abort();
    this.confirming.set(false);
    void this.router.navigate(['']);
  }
}
